var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-activity-template" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-area" },
      [
        _c(
          "el-form",
          {
            ref: "createFormref",
            staticClass: "activity-form",
            attrs: {
              model: _vm.createForm,
              rules: _vm.createRules,
              "label-width": "100px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "标题", prop: "title" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入标题" },
                  model: {
                    value: _vm.createForm.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.createForm, "title", $$v)
                    },
                    expression: "createForm.title",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "内容", prop: "content" } },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    placeholder: "请输入内容",
                    rows: 4,
                  },
                  model: {
                    value: _vm.createForm.content,
                    callback: function ($$v) {
                      _vm.$set(_vm.createForm, "content", $$v)
                    },
                    expression: "createForm.content",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "封面图", prop: "coverImage" } },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "cover-image-uploader",
                    attrs: {
                      action: "#",
                      "http-request": function (option) {
                        return _vm.handleUpload(
                          Object.assign({}, option, { filename: "coverImage" })
                        )
                      },
                      "show-file-list": false,
                      "before-upload": _vm.beforeUpload,
                    },
                  },
                  [
                    _vm.createForm.coverImage
                      ? _c("img", {
                          staticClass: "cover-image",
                          attrs: {
                            src: _vm.getImageUrl(_vm.createForm.coverImage),
                          },
                        })
                      : _c("i", {
                          staticClass: "el-icon-plus cover-image-uploader-icon",
                        }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "形象", prop: "figure" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择形象",
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.createForm.figure,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "figure", $$v)
                      },
                      expression: "createForm.figure",
                    },
                  },
                  _vm._l(_vm.avatarList, function (avatar) {
                    return _c("el-option", {
                      key: avatar.id,
                      attrs: { label: avatar.nickname, value: avatar.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "话题", prop: "topic" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择话题",
                      clearable: "",
                      filterable: "",
                    },
                    model: {
                      value: _vm.createForm.topic,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "topic", $$v)
                      },
                      expression: "createForm.topic",
                    },
                  },
                  _vm._l(_vm.topicList, function (topic) {
                    return _c("el-option", {
                      key: topic.id,
                      attrs: { label: topic.title, value: topic.title },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "分类", prop: "category" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择分类", clearable: "" },
                    model: {
                      value: _vm.createForm.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "category", $$v)
                      },
                      expression: "createForm.category",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "帖子", value: "1" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "外链", value: "2" } }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "系统链接", value: "3" },
                    }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "图片", value: "4" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.createForm.category === "2"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "外链地址", prop: "externalLink" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入外链地址" },
                      model: {
                        value: _vm.createForm.externalLink,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "externalLink", $$v)
                        },
                        expression: "createForm.externalLink",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.createForm.category === "3"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "系统链接", prop: "systemLink" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择系统链接",
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.createForm.systemLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.createForm, "systemLink", $$v)
                          },
                          expression: "createForm.systemLink",
                        },
                      },
                      _vm._l(_vm.pageList, function (page) {
                        return _c("el-option", {
                          key: page.id,
                          attrs: { label: page.pageName, value: page.pageUrl },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.createForm.category === "4"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "图片", prop: "imageFile" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "cover-image-uploader",
                        attrs: {
                          action: "#",
                          "http-request": function (option) {
                            return _vm.handleUpload(
                              Object.assign({}, option, {
                                filename: "imageFile",
                              })
                            )
                          },
                          "show-file-list": false,
                          "before-upload": _vm.beforeUpload,
                        },
                      },
                      [
                        _vm.createForm.imageFile
                          ? _c("img", {
                              staticClass: "cover-image",
                              attrs: {
                                src: _vm.getImageUrl(_vm.createForm.imageFile),
                              },
                            })
                          : _c("i", {
                              staticClass:
                                "el-icon-plus cover-image-uploader-icon",
                            }),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "通知用户", prop: "notifyUser" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.createForm.notifyUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "notifyUser", $$v)
                      },
                      expression: "createForm.notifyUser",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 0 } }, [
                      _vm._v("所有用户"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("LV1及以上"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("LV2及以上"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 3 } }, [
                      _vm._v("LV3及以上"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 4 } }, [
                      _vm._v("LV4及以上"),
                    ]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 5 } }, [
                      _vm._v("LV5及以上"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "是否通知", prop: "isNotice" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.createForm.isNotice,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "isNotice", $$v)
                      },
                      expression: "createForm.isNotice",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.goBack } }, [
                  _vm._v("取消"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-title" }, [_vm._v("新增活动模板")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }